import { createAction, handleActions } from 'redux-actions'

const startFetching = createAction('SCREENS/SUBBIES/SUB_INVOICES/START_FETCHING')
const finishFetching = createAction('SCREENS/SUBBIES/SUB_INVOICES/FINISH_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [startFetching]: () => true,
    [finishFetching]: () => false,
  },
  defaultState,
)

export { startFetching, finishFetching, reducer }
